export default "__VITE_ASSET__BZlufpq8__"